import { colors as themeColors } from '../utils/theme';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Paper, Grid, TextField, Button, Checkbox, IconButton, } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link, useNavigate } from 'react-router-dom';
import DetailCard from '../components/DetailCard';
import { FaFileExcel } from 'react-icons/fa';

const path = `http://192.168.1.248:3103/api`

function ProdGroupDetail({ loggedInUser, companyData }) {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [GroupNameSearchTerm, setGroupNameSearchTerm] = useState('');
    const [GroupCodeSearchTerm, setGroupCodeSearchTerm] = useState('');
    const [resetFlag, setResetFlag] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(5);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [mode, setMode] = useState('search');
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        fetchData(0);
        fetchTotalCount();
    }, [resetFlag, limit, mode]);

    const fetchData = async (passedOffset = 0) => {
        try {
            let apiUrl = `${path}/group/Search?mode=${mode}&offset=${passedOffset}&limit=${limit}`;
            if (mode === 'search') {
                if (resetFlag === 1) {
                    setGroupNameSearchTerm('');
                    setGroupCodeSearchTerm('');
                    setOffset(0);
                    setResetFlag(0);
                    setSelectedRows([]);
                    setSelectAll(false);
                } else {
                    apiUrl += `&GroupName=${GroupNameSearchTerm}&GroupCode=${GroupCodeSearchTerm}`;
                }
                try {
                    const response = await axios.get(apiUrl);

                    if (passedOffset === 0) {
                        setData(response.data); // fresh data
                    } else {
                        setData(prev => [...prev, ...response.data]); // append
                    }
                } catch (error) {
                    if (error.response && error.response.status === 304) {
                        // console.log("Data not found");
                    } else {
                        console.error("Error fetching data:", error);
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchTotalCount = async () => {
        try {
            const response = await axios.get(`${path}/group/count`);
            setTotalCount(response.data);
        } catch (error) {
            console.error('Error fetching total count:', error);
        }
    };

    const funExportData = () => {
        axios({
            url: `${path}/group/search?mode=${mode}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportedFileProductGroup.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setMode('search');
        });
    };

    const funSearch = () => {
        setOffset(0);
        setMode('search');
        setData([]);  // clear previous data
        fetchData(0); // pass offset = 0
        fetchTotalCount();
    };

    const funReset = () => {
        setResetFlag(1);
        setMode('search');
    };

    const funShowMore = () => {
        const newOffset = offset + limit;
        setOffset(newOffset);          // update state
        fetchData(newOffset);         // explicitly pass new offset
    };

    const funSelectAll = () => {
        const allIds = data.map(item => item.ProdGRPID);
        setSelectAll(!selectAll);
        setSelectedRows(!selectAll ? allIds : []);
    };

    const funRowSelect = (id) => { setSelectedRows(prev => prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]); };

    const funDeleteSelectedRows = async () => {
        try {
            const companyId = companyData?.[0]?.companyId;
            const userId = loggedInUser?.userId;

            await axios.post(`${path}/group/Delete`, { objAryId: selectedRows, userId, });

            funReset();
        } catch (error) {
            console.error('Error deleting selected rows:', error);
        }
    };

    return (
        <Box p={2} display="flex" flexDirection="column" gap={2}>
            {/* Header Buttons */}
            <Paper sx={{ p: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box display="flex" alignItems="center" gap={2}>
                    <IconButton onClick={() => setIsVisible(!isVisible)}><FilterListIcon /></IconButton>
                    <IconButton component={Link} to="/main/proGroupMaster" color="primary">
                        <AddIcon />
                    </IconButton>
                    <Checkbox checked={selectAll} onChange={funSelectAll} />
                    <IconButton color="error" onClick={funDeleteSelectedRows} disabled={selectedRows.length === 0}>
                        <DeleteIcon />
                    </IconButton>
                    <IconButton onClick={funExportData} color="success">
                        <FaFileExcel />
                    </IconButton>
                </Box>
            </Paper>

            {/* Filter Section */}
            {isVisible && (
                <Paper
                    sx={{
                        p: 3,
                        bgcolor: themeColors.neutral.surfaceAlt,
                        borderRadius: 2,
                        border: `1px solid ${themeColors.neutral.line}`,
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Group Name" value={GroupNameSearchTerm} onChange={(e) => setGroupNameSearchTerm(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth label="Group Code" value={GroupCodeSearchTerm} onChange={(e) => setGroupCodeSearchTerm(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} display="flex" justifyContent="center" gap={2}>
                            <Button variant="contained" onClick={funSearch}>Search</Button>
                            <Button variant="outlined" color="error" onClick={funReset}>Cancel</Button>
                        </Grid>
                    </Grid>
                </Paper>
            )}

            {/* List Display */}
            <Box display="flex" flexDirection="column" gap={2}>
                {data.map((item) => (
                    <DetailCard
                        key={item.ProdGRPID}
                        id={item.ProdGRPID}
                        title={item.GroupName}
                        avatarText={item.GroupName?.[0]}
                        subtitleList={[
                            `Code: ${item.GroupCode}`,
                            `Primary: ${item.IsPrimary === 1 ? 'True' : 'False'}`,
                            `Under Group: ${item.UnderGRP}`,
                        ]}
                        selected={selectedRows.includes(item.ProdGRPID)}
                        onSelect={funRowSelect}
                        onEdit={(id) => navigate(`/main/editProGroupMaster/${id}`)}
                        backgroundColor={themeColors.neutral.surfaceAlt}
                        sx={{
                            transition: 'all 0.2s',
                            '&:hover': {
                                boxShadow: 3,
                                transform: 'scale(1.01)',
                                cursor: 'pointer',
                            },
                        }}
                    />
                ))}

                {/* Show More Button */}
                {data.length < totalCount && (
                    <Box textAlign="center" mt={1}>
                        <Button variant="outlined" onClick={funShowMore} sx={{ borderColor: '#BA55D3', color: '#BA55D3' }} >
                            Show More: {data.length}/{totalCount}
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default ProdGroupDetail;